import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Meeting } from '@app/models/meeting';

@Injectable({
  providedIn: 'root'
})
export class MeetingsService {

constructor(private http: HttpClient) { }


getMeetings(params: Meeting) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  return this.http.post<any>(environment.apiUrl + 'Meeting/SearchMeetingsForMemberAsync', JSON.stringify(params), httpOptions);
}

getMeetingById(id: number) {
  return this.http.get<any>(environment.apiUrl + 'Meeting/GetMeetingByIdAsync/' + id);
}


getAttendantsByMeetingIdAsync(id: number) {
  return this.http.get<any>(environment.apiUrl + 'Meeting/GetAttendantsByMeetingIdAsync/' + id);
}

getMeetingReportAsync(params: Meeting) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  return this.http.post<any>(environment.apiUrl + 'Meeting/MeetingReportAsync', JSON.stringify(params), httpOptions);
}

addMeeting(params: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  return this.http.post<any>(environment.apiUrl + 'Meeting/addMeeting', JSON.stringify(params), httpOptions);
}

searchMeeting(params: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  return this.http.post<any>(environment.apiUrl + 'Meeting/searchMeeting', JSON.stringify(params), httpOptions);
}

getPossibleMeetingAttenders(meetingid: number, institutionid: number) {
  return this.http.get(environment.apiUrl + 'Meeting/GetPossibleMeetingAttenders/' + meetingid + '/' + institutionid);
}

AddMeetingAttendance(attendancedata: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  return this.http.post<any>(environment.apiUrl + 'Meeting/AddMeetingAttendance', JSON.stringify(attendancedata), httpOptions);
}
}
